<template>
  <div id="eventApp">
    <!-- <h1 style="margin-bottom: 2rem">Events test</h1> -->

    <!-- <div v-if="data">
        <section v-for="result in data.data.response.resultPacket.results" v-bind:key="result.title" >
          <div>
            <a :href="result.displayUrl">{{result.title}}</a>
            <p><small>{{result.displayUrl}}</small></p>
            <p>{{result.metaData.eventSummary}}</p>
          </div>
          <hr>
        </section>
      </div> -->

    <div>
      <div v-if="loading" class="loading">
        <svg
          xmlns:svg="http://www.w3.org/2000/svg"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.0"
          width="50px"
          height="50px"
          viewBox="0 0 128 128"
          xml:space="preserve"
        >
          <rect x="0" y="0" width="100%" height="100%" fill="#ffffff" />
          <g>
            <linearGradient id="linear-gradient">
              <stop offset="0%" stop-color="#ffffff" fill-opacity="0" />
              <stop offset="100%" stop-color="#115737" fill-opacity="1" />
            </linearGradient>
            <path
              d="M63.85 0A63.85 63.85 0 1 1 0 63.85 63.85 63.85 0 0 1 63.85 0zm.65 19.5a44 44 0 1 1-44 44 44 44 0 0 1 44-44z"
              fill="url(#linear-gradient)"
              fill-rule="evenodd"
            />
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 64 64"
              to="360 64 64"
              dur="1080ms"
              repeatCount="indefinite"
            ></animateTransform>
          </g>
        </svg>
      </div>

      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the moment
        </p>
      </section>

      <div class="articles-container">
        <ul class="events" v-if="mergedEvents">
          <component
            :id="e.title"
            v-for="e in mergedEvents"
            :key="e.title"
            :e="e"
            :is="useTemplate"
          >
          </component>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import SearchForm from "./components/SearchForm";
import Events from "./components/Events";
import Event from "./components/Event";
import EventNew from "./components/EventNew";
import DateFilter from "./components/DateFilter";
import Pagination from "./components/Pagination";
import Filters from "./components/Filters";
var AdvancedFormat = require("dayjs/plugin/customParseFormat");
var dayjs = require("dayjs");

dayjs.extend(AdvancedFormat);

export default {
  name: "app",
  components: {
    SearchForm,
    Events,
    DateFilter,
    Pagination,
    Filters,
    Event,
    EventNew
  },
  data() {
    return {
      data: null,
      events: null,
      reformattedSearchString: "",
      url: {
        root: "https://www.wgtn.ac.nz/tools/get-events-funnelback?collection=vic-events-push&sort=adate&fmo=true&meta_eventOwner=Responsive",
        query: "",
        page: 1,
        startDate: "",
        endDate: "",
        filters: [],
      },
      searched: false,
      loading: true,
      errored: false,
      startDate: null,
      isFaculty: false,
      siteName: "",
      mainEventsLink: "",
      mergedEvents: null,
      useTemplate: "Event"
    };
  },
  computed: {
    builtUrl() {
      const { root, query, page, startDate, endDate, filters } = this.url;

      let filterString = filters
        ? filters.map((filter) => `&${filter.filter}`)
        : "";
      // console.log('filter string', filterString);

      let url = `${root}&query=${
        query ? `${this.url.query}` : `!showall`
      }&start_rank=${page}${startDate ? `&meta_d3=${startDate}` : ``}${
        endDate ? `&meta_d4=${endDate}` : ``
      }${filters ? `${filterString}` : ``}`;

      return url;
    },
    resultsSummary() {
      return this.data.response.resultPacket.resultsSummary;
    },
    eventsSummary() {
      let summary = this.resultsSummary;

      if (summary.fullyMatching) {
        return `Showing events <strong>${summary.currStart}-${
          summary.currEnd
        }</strong> of <strong>${summary.fullyMatching}</strong>${
          this.reformattedSearchString
            ? ` for <strong>${this.reformattedSearchString}</strong>`
            : ``
        }`;
      } else {
        return `${
          !this.reformattedSearchString.length
            ? `<p>We host various events throughout the year. Check for university-wide events at <a href="${this.mainEventsLink}">Victoria University of Wellington events</a>.</p>`
            : ` No current events found for <strong>${this.reformattedSearchString}</strong>.`
        }`;
      }
    },
  },
  methods: {
    audienceTags(e) {
      let tagHtml = e
        .split(";")
        .map((tag) => `<span class="tag tag-grey mr1">${tag}</span>`)
        .join("");
      return tagHtml;
    },
    getData(url) {
      this.loading = true;
      this.$http
        .get(url)
        .then(
          (response) => (
            (this.data = response.data),
            (this.events = response.data.response.resultPacket.results)
          )
        )
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
          if (
            window.location.hostname.includes("cms") ||
            window.location.hostname.includes("local")
          ) {
            console.log("Fetched events url:", url);
          }
          this.formatData();
        });
    },
    compareDates(sD, eD) {
      if (sD && !eD) {
        return dayjs(sD).format("D MMM YYYY");
      } else if (sD >= (eD && dayjs(eD).isValid())) {
        return dayjs(sD).format("D MMM YYYY");
      } else {
        return `${dayjs(sD).format("D MMM")} - ${dayjs(eD).format(
          "D MMM YYYY"
        )}`;
      }
    },
    formatDate(date, form) {
      let d = dayjs(date).format(form);
      return `${d}`;
    },
    formatEventType(type) {
      if (type.includes(";")) {
        let types = type
          .split(";")
          .map((t) => `<span class="type-tag">${t.trim()}</span>`)
          .join("");
        return types;
      } else {
        return `<span>${type}</span>`;
      }
    },
    wwwUrl(url) {
      return url.replace("cms", "www");
    },
    hideEvents() {
      document.querySelector(".events-widget").style.display = "none";
    },
    formatData() {
      let searchEvents = this.events;
      let squizEvents = window.eventItems;

      let formattedSearchEvents = searchEvents
        ? searchEvents.map((event) => {
            return {
              collection: "search",
              title: event.title,
              description: event.metaData.eventSummary,
              startDate: event.metaData.startDate,
              endDate: event.metaData.endDate,
              startTime: event.metaData.eventStartTime,
              endTime: event.metaData.eventEndTime,
              url: event.displayUrl,
              image: event.metaData.image,
              imageShowCopyright: event.metaData.imageShowCopyright,
              imageCopyrightUrl: event.metaData.imageCopyrightUrl,
              imageCopyrightText: event.metaData.imageCopyright,
              imageAlt: event.metaData.t,
              eventOwner: event.metaData.eventOwner,
              eventType: event.metaData.eventType,
              eventAudience: event.metaData.eventAudience,
              location: event.metaData.eventLocation,
              blurb: event.metaData.eventBlurb ? event.metaData.eventBlurb : event.metaData.c,
            };
          })
        : [];

      console.log("search events- ", formattedSearchEvents);

      console.log(squizEvents);

      let formattedSquizEvents = squizEvents
        ? squizEvents
            .map((event) => {
              return {
                collection: "squiz",
                title: event.asset_name,
                description: event.event_summary,
                startDate: event.event_start_date,
                endDate: event.event_end_date,
                startTime: event.event_start_time_12h,
                endTime: event.event_end_time_12h,
                url: event.asset_url,
                image: event.asset_thumbnail_url,
                imageShowCopyright: event.asset_thumbnail_imageShowCopyright,
                imageCopyrightUrl: event.asset_thumbnail_imageCopyrightUrl,
                imageCopyrightText: event.asset_thumbnail_imageCopyright,
                imageAlt: event.asset_name,
                eventOwner: event.site_name,
                eventType: event.asset_metadata_eventsTagCategory_value,
                eventAudience: event.asset_metadata_eventsTagAttribute,
                location: event.asset_metadata_eventVenue,
                eventOwnerEventsLink: event.site_eventsAsset,
                blurb: event.asset_metadata_eventBlurb,
              };
            })
            .filter((e) => dayjs(e.startDate) >= dayjs().subtract(1, "day"))
        : [];

      console.log("SQUIZ events- ", formattedSquizEvents);

      let mergedEvents = [...formattedSearchEvents, ...formattedSquizEvents];

      console.log("mergedEvents---", mergedEvents);

      if (mergedEvents.length <= 0) {
        this.hideEvents();
      }

      this.mergedEvents = mergedEvents.sort(
        (a, b) => dayjs(a.startDate) - dayjs(b.startDate)
      );
    },
    search(searchParams) {
      // this.api.q = searchParams.join('+');
      // const { baseUrl, part, type, order, maxResults, q, key, boo, page } = this.api;
      // const apiUrl = `${baseUrl}${q}&start_rank=${page}`;
      // console.log('aipurl= ',apiUrl);

      if (searchParams) {
        console.log("search params", searchParams);

        this.reformattedSearchString = searchParams.join(" ");
        this.url.query = searchParams.join("+");
        this.url.page = 1;

        this.loading = true;
        this.getData(this.builtUrl);
      } else {
        this.reformattedSearchString = "";
        this.url.query = "";
        this.url.page = 1;
        this.loading = true;
        this.getData(this.builtUrl);
      }
    },
    nextPage() {
      // const { baseUrl, q, page } = this.api;

      // this.api.page = this.api.page + 10;
      // let apiUrl = `${baseUrl}${q}&start_rank=${this.api.page}`;
      // this.getData(apiUrl);

      this.url.page += 10;
      console.log("pagination..", this.url.page);
      this.getData(this.builtUrl);
    },
    previousPage() {
      // const { baseUrl, q, page } = this.api;

      // this.api.page = this.api.page + 10;
      // let apiUrl = `${baseUrl}${q}&start_rank=${this.api.page}`;
      // this.getData(apiUrl);

      this.url.page -= 10;
      console.log("pagination..", this.url.page);
      this.getData(this.builtUrl);
    },
    updateUrlMethod() {
      if (
        window.location.hostname.includes("cms") ||
        window.location.hostname.includes("local")
      ) {
        console.log("date set update url ", this.builtUrl);
      }

      this.getData(this.builtUrl);
    },
    updateFiltersMethod(filter, facet) {
      console.log("update filter clicked", filter);
      console.log("update filter clicked", facet);
      // this.url.filters.push(filter)
      // this.getData(this.builtUrl)

      // for select filters, above was when using filter buttons..
      if (this.url.filters.length) {
        let filteredFacets = this.url.filters.filter(
          (value) => value.facet !== facet
        );
        console.log(facet, filter);

        if (filter) {
          filteredFacets.push({ filter: filter, facet: facet });
        }

        console.log(filteredFacets);
        this.url.filters = filteredFacets;
      } else {
        this.url.filters.push({ filter: filter, facet: facet });
      }
      this.url.page = 1;
      this.getData(this.builtUrl);
    },
    removeFilterMethod(filter) {
      console.log("remove ", this.url.filters);
      let newFilters = this.url.filters.filter((value) => value !== filter);

      this.url.filters = newFilters;
      console.log("new filters update", newFilters);
      console.log("data filters ", this.url.filters);
      console.log(filter);
      this.getData(this.builtUrl);
    },
  },
  mounted() {
    this.url.root = window.eventsFeedPath;
    this.isFaculty = window.isFaculty ? window.isFaculty : false;
    this.siteName = window.siteName ? window.siteName : "";
    this.mainEventsLink = window.mainEventsLink ? window.mainEventsLink : "";

    let isHubV4 = document.querySelector("#hubv4");
    console.log("is v4 ", isHubV4);
    if (isHubV4) {
      this.useTemplate = "EventNew";
    } else {
      this.useTemplate = "Event";
    }

    this.loading = true;
    this.getData(this.builtUrl);

  },
};
</script>

<style lang="scss" >
#eventApp {
  .loading {
    fill: red;
  }
  .events-container {
    display: flex;
    align-items: flex-start;

    .results {
      flex: 1 1 70%;
      margin-right: 1.5rem;
    }
  }

  .type-tag {
    display: block;
    font-size: 0.9rem;
  }

  .event-tag {
    display: inline-block;
    margin: 1rem 0;
    border-left: 5px solid #347056;
    padding: 0.5rem 1rem;
    background-color: #ecf2f0;
    border-radius: 2px;
    font-size: 0.9rem;
  }

  .tag.tag-grey {
    font-size: 0.8rem;
    margin-top: 0.5rem;
    border-radius: 4px;
  }

  .filter-sidebar {
    flex: 1 0 30%;
    .filters-wrap {
      background-color: #eee;
      margin: 0 0 1.5rem 0;
      border-radius: 4px;

      h2,
      h3,
      h4,
      h5 {
        color: #424242;
        margin-bottom: 0.5rem;
      }

      .filters-flex {
        // display: flex;

        .filters-search-date {
          flex: 1 1 50%;
          // padding-right: .5rem;
        }

        .filters {
          flex: 1 1 50%;
          // padding-left: .5rem;
        }
      }
    }
  }

  button {
    &::after {
      content: none;
    }
  }

  @media (max-width: 900px) {
    .events-container {
      flex-direction: column-reverse;
      .results {
        flex: 1 1 100%;
        margin-right: 1.5rem;
      }
    }

    .filter-sidebar {
      flex: 1 1 100%;
      width: 100%;
    }
  }
  @media (min-width: 43em) {
    .media.inline {
      width: 15rem;
    }
  }
}

.breadcrumbs {
  display: flex;
  align-items: center;
}
</style>


// https://search.wgtn.ac.nz/s/search.html?collection=vic-events-push&query=!showall&meta_startDate=20200527